import React from 'react';
import qs from 'qs';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as reducers from 'Store/reducers';
import {
  getCookie,
  setUserTypeCookie,
  deleteSessionStorage,
} from '../utilities';

import ContentFrame from 'Components/ContentFrame';
import SectionSlider from 'Components/SectionSlider';
import LoginSwitcher from 'Components/LoginSwitcher';
import TeacherLoginForm from 'Containers/TeacherLoginForm';
import StudentLoginForm from 'Containers/StudentLoginForm';
import Loading from 'Components/Loading';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';
import { ROUTES } from 'Settings/route-strings';

class LoginPage extends React.Component {
  constructor(props) {
    super(props);

    const formType = getCookie('tbsUserType') || 'students';
    this.state = {
      formType,
    };

    this.handleTabClick = this.handleTabClick.bind(this);
  }

  componentDidMount() {
    if (this.props.activeUser) {
      deleteSessionStorage('loggedOutPayment');
    }
  }

  componentDidUpdate() {
    if (this.props.activeUser) {
      deleteSessionStorage('loggedOutPayment');
    }
  }

  handleTabClick(formType) {
    this.setState({ formType });
    setUserTypeCookie(formType);
  }

  render() {
    const {
      isFetchingActiveUser,
      authToken,
      activeUser,
      location,
      isAuthTokenExpired,
      failedLoginErrorVars,
    } = this.props;

    if (isFetchingActiveUser && authToken) {
      return <Loading />;
    }

    const { redirect } = qs.parse(location.search, { ignoreQueryPrefix: true });
    let next = redirect || ROUTES.EXPLORE;
    console.log('FAILED login vars', failedLoginErrorVars);
    if (failedLoginErrorVars && failedLoginErrorVars.redirectRoute) {
      const { user, school, license, redirectRoute } = failedLoginErrorVars;
      if (
        (redirect === ROUTES.SETTINGS_SUBSCRIPTION_PAYMENT ||
          redirect === ROUTES.SETTINGS_SUBSCRIPTION_ACTIVATION) &&
        typeof user === 'object' &&
        typeof school === 'object' &&
        typeof license === 'object'
      ) {
        return <Redirect to={redirectRoute} />;
      }
      return <Redirect to={ROUTES.ERROR_EXPIRED_TRIAL} />;
    }

    if (activeUser && !isAuthTokenExpired) {
      return <Redirect to={next} />;
    }

    const { formType } = this.state;
    const externalHeader = (
      <LoginSwitcher
        handleTabClick={this.handleTabClick}
        activeTab={this.state.formType}
      />
    );

    return (
      <main className="Page__content">
        <ContentFrame
          pageType="transactional"
          size="small"
          externalHeader={externalHeader}
        >
          <SectionSlider
            activeSection={formType === 'teachers' ? 'b' : 'a'}
            a={<StudentLoginForm />}
            b={<TeacherLoginForm />}
          />
        </ContentFrame>
      </main>
    );
  }
}

const mapStateToProps = state => {
  return {
    authToken: reducers.getAuthToken(state),
    activeUser: reducers.getActiveUser(state),
    failedLoginErrorVars: reducers.getFailedLoginErrorVars(state),
    isFetchingActiveUser: reducers.getIsFetchingActiveUser(state),
    isAuthTokenExpired: reducers.isAuthTokenExpired(state),
  };
};

LoginPage.propTypes = {
  authToken: PropTypes.string,
  activeUser: PropTypes.object,
  failedLoginErrorVars: PropTypes.object,
  isFetchingActiveUser: PropTypes.bool,
  isAuthTokenExpired: PropTypes.bool,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired,
  }),
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

export default connect(mapStateToProps)(withRouter(LoginPage));
